// @flow
import React, { Component } from 'react';
import {
  CurrencyDetailDiv,
  CurrencyNameH2,
  RevenueShareH2
} from './CommissionsStyles';
import { type CommissionStat } from '..';
import { type Currencies } from '../../../../utilities/types';
import { formatCurrency } from '../../../../utilities/numberFormatting';
import { DefaultIcon } from '../../../../components/Icon';

type Props = {
  ...$Exact<CommissionStat>,
  currencies: Currencies
};

export default class CurrencyDetail extends Component<Props> {
  render() {
    const currency = this.props.currencies[this.props.currency];
    return (
      <CurrencyDetailDiv>
        <CurrencyNameH2 color={currency.color}>
          <DefaultIcon
            name={currency.iso4217.toLowerCase()}
            color={currency.color}
          />
          {currency.currency_type === 'fiat' ? currency.iso4217 : currency.name}
        </CurrencyNameH2>
        <RevenueShareH2>
          {formatCurrency(this.props.revenue_share, currency)}
        </RevenueShareH2>
      </CurrencyDetailDiv>
    );
  }
}
